if (typeof debounce === "undefined") {
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
/**
 *  @class
 *  @function ThemeHeader
 */
if (!customElements.get("theme-header")) {
  class ThemeHeader extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.header_section = document.querySelector(".header-section");
      this.menu = this.querySelector("#mobile-menu");
      this.toggle = document.querySelector(".mobile-toggle-wrapper");

      this.setupMobileMenu();

      // Sticky Header Class
      window.addEventListener("scroll", this.setStickyClass.bind(this), {
        passive: true,
      });
      // Mobile Menu offset
      window.addEventListener("scroll", this.setHeaderOffset.bind(this), {
        passive: true,
      });
      window.addEventListener("scroll", this.setHeaderHeight.bind(this), {
        passive: true,
      });

      window.dispatchEvent(new Event("scroll"));

      if (document.querySelector(".announcement-bar-section")) {
        window.addEventListener("scroll", this.setAnnouncementHeight(), {
          passive: true,
        });
        window.dispatchEvent(new Event("resize"));
      }

    }

    setHeaderProperty(name, value) {
      const style = document.documentElement.style;
      if (style.getPropertyValue(name) !== value) style.setProperty(name, value);
    }

    setStickyClass() {
      if (this.classList.contains("header-sticky--active")) {
        let offset =
          parseInt(this.getBoundingClientRect().top, 10) +
          document.documentElement.scrollTop;
        this.classList.toggle(
          "is-sticky",
          this.toggle?.open || (window.scrollY >= offset && window.scrollY > 0),
        );
      }
    }
    setAnnouncementHeight() {
      const a_bar = document.getElementById("shopify-section-announcement-bar");
      if (a_bar) {
        let h = a_bar.clientHeight;
        this.setHeaderProperty("--announcement-height", h + "px");
      }
    }
    setHeaderOffset() {
      let h = this.header_section.getBoundingClientRect().top;
      this.setHeaderProperty("--header-offset", h + "px");
    }
    setHeaderHeight() {
      let h = this.clientHeight;
      this.setHeaderProperty("--header-height", h + "px");
    }
    setupMobileMenu() {
      this.mobileEvents?.abort();
      this.mobileEvents = new AbortController();
      const options = { signal: this.mobileEvents.signal };
      this.mobileTrigger = this.toggle.querySelector(".mobile-toggle");
      this.mobileClose = this.mobileTrigger;
      this.mobileScroll = this.menu.querySelector(".mobile-tabs-scroll");
      this.mobileRootTitle = this.menu.getAttribute("aria-label");
      this.mobileTabs = [...this.menu.querySelectorAll("[role=tab]")];
      this.mobilePanels = [...this.menu.querySelectorAll("[role=tabpanel]")];
      this.mobileTrigger.setAttribute("aria-expanded", "false");
      this.mobileTrigger.addEventListener("click", (event) => {
        event.preventDefault();
        if (this.toggle.open) this.closeMobileMenu();
        else this.openMobileMenu();
      }, options);
      this.menu.querySelector("#MobileMenuCountry")?.addEventListener("change", (event) => event.target.form.requestSubmit(), options);
      this.mobileTabs.forEach((tab, index) => {
        tab.addEventListener("click", () => this.selectMobileTab(index), options);
        tab.addEventListener("keydown", (event) => {
          const rtl = getComputedStyle(this.menu).direction === "rtl";
          let next = index;
          if (event.key === "ArrowRight") next += rtl ? -1 : 1;
          else if (event.key === "ArrowLeft") next += rtl ? 1 : -1;
          else if (event.key === "Home") next = 0;
          else if (event.key === "End") next = this.mobileTabs.length - 1;
          else return;
          event.preventDefault();
          next = (next + this.mobileTabs.length) % this.mobileTabs.length;
          this.selectMobileTab(next);
          this.mobileTabs[next].focus();
        }, options);
      });
      this.selectMobileTab(0);
      document.addEventListener("keydown", (event) => {
        if (!this.toggle.open) return;
        if (event.key === "Escape") {
          event.preventDefault();
          event.stopPropagation();
          this.closeMobileMenu();
        } else if (event.key === "Tab") {
          const items = [this.mobileTrigger, ...this.menu.querySelectorAll('a[href], button, summary, select, input, [tabindex="0"]')]
            .filter((item) => !item.disabled && item.tabIndex >= 0 && !item.closest("[hidden], [inert]") && item.getClientRects().length && getComputedStyle(item).visibility !== "hidden");
          const first = items[0];
          const last = items[items.length - 1];
          if (!first) return;
          if (event.shiftKey && (document.activeElement === first || !items.includes(document.activeElement))) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && (document.activeElement === last || !items.includes(document.activeElement))) {
            event.preventDefault();
            first.focus();
          }
        }
      }, { ...options, capture: true });
      const desktop = window.matchMedia("(min-width: 1068px)");
      desktop.addEventListener("change", () => {
        if (desktop.matches && this.toggle.open) this.closeMobileMenu(false);
        this.setHeaderOffset();
        this.setHeaderHeight();
      }, options);
      window.addEventListener("pageshow", (event) => {
        if (event.persisted && this.toggle.open) this.closeMobileMenu(false);
      }, options);
    }
    openMobileMenu() {
      this.toggle.open = true;
      this.toggle.classList.add("active");
      this.setStickyClass();
      this.mobileTrigger.setAttribute("aria-expanded", "true");
      this.mobileTrigger.setAttribute("aria-label", this.mobileTrigger.dataset.closeLabel);
      this.toggle.setAttribute("role", "dialog");
      this.toggle.setAttribute("aria-label", this.mobileRootTitle);
      this.toggle.setAttribute("aria-modal", "true");
      this.mobileHadScrollLock = document.body.classList.contains("overflow-hidden");
      document.body.classList.add("overflow-hidden");
      this.mobileInertElements = [];
      for (let branch = this.toggle; branch && branch !== document.body; branch = branch.parentElement) {
        for (const sibling of branch.parentElement.children) {
          if (sibling !== branch && !sibling.inert && !["SCRIPT", "STYLE", "LINK"].includes(sibling.tagName)) {
            sibling.inert = true;
            this.mobileInertElements.push(sibling);
          }
        }
      }
      this.setHeaderOffset();
      this.mobileScroll.scrollTop = 0;
      requestAnimationFrame(() => {
        if (this.toggle.open) this.mobileClose.focus({ preventScroll: true });
      });
    }
    closeMobileMenu(restoreFocus = true) {
      this.toggle.open = false;
      this.toggle.classList.remove("active");
      this.setStickyClass();
      this.mobileTrigger.setAttribute("aria-expanded", "false");
      this.mobileTrigger.setAttribute("aria-label", this.mobileRootTitle);
      this.toggle.removeAttribute("aria-modal");
      this.toggle.removeAttribute("role");
      this.toggle.removeAttribute("aria-label");
      if (!this.mobileHadScrollLock) document.body.classList.remove("overflow-hidden");
      this.mobileInertElements?.forEach((element) => { element.inert = false; });
      this.mobileInertElements = [];
      if (restoreFocus) this.mobileTrigger.focus({ preventScroll: true });
    }
    selectMobileTab(index) {
      this.mobileTabs.forEach((tab, i) => {
        const selected = i === index;
        tab.setAttribute("aria-selected", String(selected));
        tab.tabIndex = selected ? 0 : -1;
        this.mobilePanels[i].hidden = !selected;
      });
      this.mobileScroll.scrollTop = 0;
    }
    disconnectedCallback() {
      if (this.toggle?.open) this.closeMobileMenu(false);
      this.mobileEvents?.abort();
      this.headerEvents?.abort();
      this.headerObserver?.disconnect();
      cancelAnimationFrame(this.headerFrame);
      this.headerFrame = null;
    }
  }
  customElements.define("theme-header", ThemeHeader);
}
/**
 *  @class
 *  @function FullMenu
 */
if (!customElements.get("full-menu")) {
  class FullMenu extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.submenus = this.querySelectorAll(
        ".thb-full-menu>.menu-item-has-children:not(.menu-item-has-megamenu)>.sub-menu",
      );

      if (!this.submenus.length) {
        return;
      }
      const _this = this;
      // resize on initial load
      window.addEventListener(
        "resize",
        debounce(function () {
          _this.resizeSubMenus();
        }, 100),
      );

      window.dispatchEvent(new Event("resize"));

      document.fonts.ready.then(function () {
        _this.resizeSubMenus();
      });
    }
    resizeSubMenus() {
      this.submenus.forEach((submenu) => {
        let sub_submenus = submenu.querySelectorAll(
          ":scope >.menu-item-has-children>.sub-menu",
        );

        sub_submenus.forEach((sub_submenu) => {
          let w = sub_submenu.offsetWidth,
            l =
              sub_submenu.parentElement.parentElement.getBoundingClientRect()
                .left +
              sub_submenu.parentElement.parentElement.clientWidth +
              10,
            total = w + l;
          if (total > document.body.clientWidth) {
            sub_submenu.parentElement.classList.add("left-submenu");
          } else if (
            sub_submenu.parentElement.classList.contains("left-submenu")
          ) {
            sub_submenu.parentElement.classList.remove("left-submenu");
          }
        });
      });
    }
  }
  customElements.define("full-menu", FullMenu);
}


